export default values => ({
  ...values,
  address: values.address || '',
  exteriorNumber: values.exteriorNumber || '',
  interiorNumber: values.interiorNumber || '',
  zipCode: values.zipCode || '',
  neighborhood: values.neighborhood || '',
  municipality: values.municipality || '',
  city: values.city || '',
  state: values.state || '',
  country: 'MX'
});
